import { SelectedSectionActionsMenuQuery } from '../../../../components/selected_section_actions_menu/queries/selected_section_actions_menu_query';
import { CourseSchedulerConstant } from '../../constants/course_scheduler_constants';
import { TermScheduleFlags } from '../../services/term_schedule_flags';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { HILForm } from '../../../../main';

interface IHeadersDescriptionDialog {
  heading: string;
  description: string;
  content?: string;
}

class ScheduledSections {
  private oneClickEnabled: boolean;
  private isBatchRegisterWaitlistedStudentsEnabled: boolean;
  private headersDescriptionDialog: Record<string, IHeadersDescriptionDialog>;
  private submitScheduledSectionsFormBound: () => void;

  constructor(
    private ngScheduledSectionsQuery: IQuery,
    private ngRegistrationReceiptQuery: IQuery,
    private ngCourseSchedulerConstant: typeof CourseSchedulerConstant,
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngSelectedSectionActionsMenuQuery: SelectedSectionActionsMenuQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private $element: ng.IAugmentedJQuery
  ) {
    this.submitScheduledSectionsFormBound = this.onFormSubmission.bind(this);
  }

  $onInit() {
    this.oneClickEnabled = this.ngTermScheduleFlags.isOneClickRegistrationEnabled();
    this.isBatchRegisterWaitlistedStudentsEnabled = this.ngTermScheduleFlags.isBatchRegisterWaitlistedStudentsEnabled();
    this.headersDescriptionDialog = this.getHeadersDescriptionDialog();
    this.ngComponentCommunicatorService.subscribe(
      'SUBMIT_SCHEDULED_SECTIONS_FORM',
      this.submitScheduledSectionsFormBound
    );
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release(
      'SUBMIT_SCHEDULED_SECTIONS_FORM',
      this.submitScheduledSectionsFormBound
    );
  }

  onFormSubmission() {
    const scheduledSectionsForm = this.$element[0].querySelector(
      `hi-form[name="${this.ngCourseSchedulerConstant.scheduledSectionFormId}"]`
    ) as HILForm;
    if (!scheduledSectionsForm) {
      return;
    }
    scheduledSectionsForm.submit();
  }

  getHeadersDescriptionDialog() {
    return {
      waitlistedCourses: {
        heading: 'Waitlisted Courses',
        description: 'These courses are pending on a waitlist status and are not yet registered',
        content: this.getWaitlistedCoursesDescription()
      },
      courseSectionsNeeded: {
        heading: 'Course Sections Needed',
        description: 'Plan requires additional course sections to register.'
      },
      scheduledCourses: {
        heading: 'Scheduled Courses (Not Registered)',
        description:
          'You have scheduled these courses, but still need to register for them. Click the "Register" button to do so.'
      },
      registeredCourses: {
        heading: 'Registered Courses',
        description: 'You may drop or withdraw from here.'
      },
      widthdrawnCourses: {
        heading: 'Withdrawn Courses',
        description: 'These courses have been withdrawn.'
      }
    };
  }

  getWaitlistedCoursesDescription() {
    const waitlistDescription = this.isBatchRegisterWaitlistedStudentsEnabled
      ? '<p>You may add yourself to the waitlist if a class has no seats left. If a seat becomes available, you will be automatically registered in the order of your position on the waitlist.</p>'
      : '<p>You may add yourself to the waitlist if a class has no seats left. If a seat becomes available, your school will notify you to register, you may do so from here.</p>';
    return '<h3 class="ptsxx">What is Waitlist?</h3>' + waitlistDescription;
  }
}

angular.module('capability-ng-scheduler').component('scheduledSections', {
  templateUrl:
    'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_sections/scheduled_sections_component.html',
  controller: ScheduledSections
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_sections/scheduled_sections_component.ts